import React, { useEffect, useState } from 'react';
import {
    Badge,
    Card,
    Row,
    Col,
    Container,
    Image,
} from 'react-bootstrap';
import moment from "moment";
import { convertCurrency, numberFormat, convertOrderStatus } from '../../helper';
import { GET_EXCHANGE_RATE } from '../../apollo/product/query';
import { useLazyQuery } from '@apollo/client';
import { COLOR_WHITE, imageRender } from '../../const';
import { FaLuggageCart } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

import noProductImg from "../../images/no_product.png";

// Helper functions (implemented locally if not in global helpers)
const convertOrderType = (type, t) => {
    switch (type) {
        case 'POS':
            return t("order_type_pos");
        case 'ONLINE':
            return t("order_type_online");
        case 'LIVE':
            return t("order_type_live");
        default:
            return type || '-';
    }
};

const convertLogicticsName = (name) => {
    return name || "-";
};

const convertPriceWithCommission = (totalPrice, sumPriceBaht, sumPriceUsd, commission, rate) => {
    const kip = Number(totalPrice ?? 0) || 0;
    const baht = Number(sumPriceBaht ?? 0) || 0;
    const usd = Number(sumPriceUsd ?? 0) || 0;
    const extra = Number(commission ?? 0) || 0;

    const bahtRate = Number(rate?.baht) > 0 ? Number(rate?.baht) : 1;
    const usdRate = Number(rate?.usd) > 0 ? Number(rate?.usd) : 1;

    return kip + baht * bahtRate + usd * usdRate + extra;
};

export default function SalepageOrderDetail({ selectedOrderGroup }) {
    const { t } = useTranslation();

    const [shopRate, setShopRate] = useState()

    const [getExchangeRate, { data: loadExchangeRate, loading: loadingExchangeRate }] = useLazyQuery(GET_EXCHANGE_RATE, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        if (loadExchangeRate) {
            setShopRate(loadExchangeRate?.exchangeRate)
        }
    }, [loadExchangeRate])

    //   fetch exchange ret
    useEffect(() => {
        if (selectedOrderGroup?.shop?.id) {
            getExchangeRate({
                variables: {
                    where: {
                        shop: selectedOrderGroup?.shop?.id,
                    },
                },
            });
        }
    }, [selectedOrderGroup]);

    if (!selectedOrderGroup) return null;
    const createdAtText = moment(selectedOrderGroup?.createdAt).isValid()
        ? moment(selectedOrderGroup?.createdAt).format("DD/MM/YYYY HH:mm")
        : (selectedOrderGroup?.createdAt ?? "-");
    console.log("selectedOrderGroup?.orders", selectedOrderGroup?.orders);
    console.log("selectedOrderGroup", selectedOrderGroup);
    
    return (
        <Container className="py-4">

            {/* Order Header */}
            <Row className="mb-4">
                <Col md={6}>
                    <h6>{t("customer_label")}: {selectedOrderGroup?.cfName ?? selectedOrderGroup?.customerName ?? "-"}</h6>
                    <p>{t("phone_label")}: {selectedOrderGroup?.phone ?? "-"}</p>
                    <p>{t("date_label")} {createdAtText}</p>
                </Col>
                <Col md={6}>
                    <p>
                        {t("payment_label")}: {" "}
                        <Badge bg={selectedOrderGroup?.isPaymented ? "success" : "danger"}>
                            {selectedOrderGroup?.isPaymented ? t("paid") : t("not_paid")}
                        </Badge>
                    </p>
                    {/* <p>ຫົວຂໍ້: {selectedOrderGroup?.live?.description ?? "-"}</p> */}
                    {/* <p>ທວງຍອດ: {selectedOrderGroup?.isClaimBalance ? "ທວງຍອດແລ້ວ" : "ຍັງບໍທວງຍອດ"}</p> */}
                    <p>{t("pay_shipping_label")}: {selectedOrderGroup?.orderDelivery?.shipmentPayType === "COD" ? t("payment_destination") : t("payment_origin")}</p>
                    <p>{t("order_status_label")}: {convertOrderStatus(selectedOrderGroup?.status)}</p>
                    <p>{t("type_label")}: {convertOrderType(selectedOrderGroup?.type, t)}</p>
                </Col>
            </Row>
            <hr />

            {/* Order Items */}
            <Card style={{ boxShadow: 'none', border: 'none', background: COLOR_WHITE }} className="mb-4">
                <Card.Body>
                    <Card.Text>
                        {t("order_items_title")}
                    </Card.Text>
                    {selectedOrderGroup?.orders?.map((item) => (
                        <Row key={item.id} className="align-items-center mb-3 border-bottom">
                            <Col md={2}>
                                <Image
                                    src={item?.stock?.image?.length ? imageRender(item?.stock?.image) : noProductImg}
                                    alt={item?.cfMessage}
                                    className="img-fluid rounded"
                                    style={{ width: 60 }}
                                />
                            </Col>
                            <Col md={6}>
                                <h5>{item?.productName} </h5>
                                <p className="text-muted">{t("code_label")}: {item?.cfMessage || item?.stock?.cfMessage}</p>
                            </Col>
                            <Col md={2} className="text-end">
                                <p>{convertCurrency(item?.currency)} {numberFormat(item?.totalPrice)}</p>
                            </Col>
                            <Col md={2} className="text-end">
                                <p>{t("quantity_label")}: ({item?.amount})</p>
                            </Col>
                        </Row>
                    ))}
                </Card.Body>
            </Card>

            <Row>
                {/* Delivery Information */}
                <Col md={6}>
                    <Card style={{ boxShadow: 'none' }} className="mb-4">
                        <Card.Body>
                            <h5>
                                {t("delivery")} {convertLogicticsName(
                                    selectedOrderGroup?.orderDelivery?.delivery || selectedOrderGroup?.logistic || ""
                                )}
                            </h5>
                            <p>
                                <strong>{t("tracking_no_label")}:</strong> {selectedOrderGroup?.orderDelivery?.deliveryTackingNo ?? "-"}
                            </p>

                            {selectedOrderGroup?.orderDelivery?.id ? <p>
                                <strong>{t("delivery_address_label")}:</strong> ({selectedOrderGroup?.orderDelivery?.receiver?.branchCode ?? "-"}), {selectedOrderGroup?.orderDelivery?.receiver?.province}, {selectedOrderGroup?.orderDelivery?.receiver?.district},{' '}
                                {selectedOrderGroup?.orderDelivery?.receiver?.branch}
                            </p> :
                                <p>
                                    <strong>{t("delivery_address_label")}: {selectedOrderGroup?.destinationLogistic ?? "-"} </strong> 
                                </p>
                            }

                            <p className="text-success">
                                <FaLuggageCart style={{ fontSize: 28, marginRight: 6 }} />
                                {t("other_shipping_label")}: {selectedOrderGroup?.addressCf ?? ""}
                            </p>
                        </Card.Body>
                    </Card>
                </Col>


                {/* Order Summary */}
                <Col md={6}>
                    <Card style={{ boxShadow: 'none' }}>
                        <Card.Body>
                            <h5>{t("order_summary_title")}</h5>
                            <Row className="mb-2 text-muted">
                                <Col>{t("total_kip_label")}:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.totalPrice ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>{t("total_baht_label")}:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.sumPriceBaht ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>{t("total_usd_label")}:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.sumPriceUsd ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>{t("tax_label")}:</Col>
                                <Col className="text-end">0</Col>
                            </Row>
                            <hr />
                            <Row className="fw-bold">
                                <Col>{t("amount_paid_label")}:</Col>
                                <Col className="text-end">{numberFormat(convertPriceWithCommission(selectedOrderGroup?.totalPrice, selectedOrderGroup?.sumPriceBaht, selectedOrderGroup?.sumPriceUsd, 0, shopRate))} {t("kip_currency")}</Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
        </Container>
    );
}
